"use client";

import { EhrInstructionsCard } from "@/src/components/ehr-instructions-card";
import { Alert, AlertDescription } from "@/src/components/shadcn/ui/alert";
import { Button } from "@/src/components/shadcn/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/src/components/shadcn/ui/tooltip";

import type { ReactNode } from "react";

interface ReferralAuthInstructionsCardProps {
  instruction: ReactNode;
  openButtonTooltip: string;
  isOpenButtonDisabled: boolean;
  isOpening: boolean;
  onOpenAuthorization: () => void;
  footer?: ReactNode;
}

export function ReferralAuthInstructionsCard({
  instruction,
  openButtonTooltip,
  isOpenButtonDisabled,
  isOpening,
  onOpenAuthorization,
  footer,
}: ReferralAuthInstructionsCardProps) {
  return (
    <EhrInstructionsCard>
      <div className="text-sm text-muted-foreground flex flex-col gap-4">
        <p className="font-medium text-center text-foreground">Referral Authorization Instructions</p>

        <Alert>
          <AlertDescription>{instruction}</AlertDescription>
        </Alert>

        {footer}

        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex w-full">
                <Button
                  variant="outline"
                  className="w-full border-primary text-primary hover:bg-primary/10"
                  onClick={onOpenAuthorization}
                  disabled={isOpenButtonDisabled}
                >
                  {isOpening ? "Opening..." : "Open Authorization"}
                </Button>
              </span>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs text-center">
              {openButtonTooltip}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </EhrInstructionsCard>
  );
}
